import { endpoint } from './endpoints';

export const fetchRestaurantCms = async () => {
  const params = new URLSearchParams({ role: 'Restaurant' });
  const response = await fetch(
    `${process.env.REACT_APP_ACCOUNTANT_API}${endpoint.cms}?${params.toString()}`
  );

  return response.json();
};

export const decodeHtml = (value = '') => {
  if (!value) return '';

  if (typeof document === 'undefined') {
    return value
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'");
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
};

export const getCmsDescriptionHtml = (item) => decodeHtml(item?.description || '');

export const getCmsDescriptionText = (item) => {
  const html = getCmsDescriptionHtml(item);

  if (!html) return '';

  if (typeof document === 'undefined') {
    return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  return (wrapper.textContent || wrapper.innerText || '').replace(/\s+/g, ' ').trim();
};
